import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";

interface MembershipTierSelectProps {
  value?: string;
  onValueChange: (value: string) => void;
}

// This maps the eligibility criteria display to the group values used in the database
export const eligibilityCriteriaToTierMapping = {
  "Eligibility Criteria 1": "Group 1",
  "Eligibility Criteria 2": "Group 2",
  "Eligibility Criteria 3": "Group 3",
  "Eligibility Criteria 4": "Group 4",
};

export const tierToEligibilityCriteriaMapping = {
  "Group 1": "Eligibility Criteria 1",
  "Group 2": "Eligibility Criteria 2",
  "Group 3": "Eligibility Criteria 3",
  "Group 4": "Eligibility Criteria 4",
};

const MembershipTierSelect = ({
  value,
  onValueChange,
}: MembershipTierSelectProps) => {
  const eligibilityCriterias = [
    {
      value: "Eligibility Criteria 1",
      label: "High School Performance",
      description: "Graduates with a GPA of 99%",
    },
    {
      value: "Eligibility Criteria 2",
      label: "Bachelor's Degree",
      description: "Bachelor's from Top 100 University",
    },
    {
      value: "Eligibility Criteria 3",
      label: "Master's Degree",
      description: "Master's from Top 100 University",
    },
    {
      value: "Eligibility Criteria 4",
      label: "PhD",
      description: "PhD from Top 100 University",
    },
  ];

  return (
    <div>
      <div className="mb-4 p-3 bg-neutral-50 rounded-lg border border-neutral-light">
        <p className="text-sm text-gray-700 font-verona">
          <span className="font-semibold">Note:</span> We consider a Top 100
          University to be one ranked in the top 100 of any of these systems:
          <span className="block mt-1 ml-2">
            • QS World University Rankings
            <br />
            • Times Higher Education (THE) World University Rankings
            <br />• Academic Ranking of World Universities (ARWU/Shanghai
            Rankings)
          </span>
          You can check if your university is listed in any of these rankings
          for your graduation year.
        </p>
      </div>

      <label
        htmlFor="tier"
        className="block text-sm font-medium text-gray-700 mb-1 font-verona"
      >
        Select Eligibility Criteria *
      </label>
      <Select value={value} onValueChange={onValueChange}>
        <SelectTrigger className="w-full px-4 py-2 border-2 border-neutral-light rounded-lg focus:ring-2 focus:ring-secondary/20 focus:border-secondary outline-none transition-all bg-white text-gray-900 font-verona">
          <SelectValue
            placeholder="Select your eligibility criteria"
            className="font-verona"
          />
        </SelectTrigger>
        <SelectContent className="bg-white border shadow-lg font-verona">
          {eligibilityCriterias.map((criteria) => (
            <SelectItem
              key={criteria.value}
              value={criteria.value}
              className="focus:bg-[#233A74] focus:text-white hover:bg-[#233A74] hover:text-white data-[highlighted]:bg-[#233A74] data-[highlighted]:text-white font-verona"
            >
              <div className="flex items-center font-verona">
                <span className="font-verona">
                  {criteria.label}: {criteria.description}
                </span>
              </div>
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  );
};

export default MembershipTierSelect;
